<a class="link-color" (click) = redirectToDetail()
   particleAnalytics
   analyticsCategory= "company-id-cell-viewer"
   analyticsAction= "company-id"
   [analyticsName]="item.cells[fieldDefinition.key]?.displayText">
  {{ item.cells[fieldDefinition.key]?.displayText }}
</a>
